import { gql } from 'types/__generated__/gql';

const KEY_ACTIVE_STUDENT_REPORT_ASYNC_QUERY = gql(/* GraphQL */ `
  query keyActiveStudentsReportAsync($where: KeyReportWhereInput!, $dateRange: DateRangeInput!) {
    keyActiveStudentsReportAsync(where: $where, dateRange: $dateRange) {
      id
      error
      result {
        activeStudentCount
        totalStudentCount
      }
    }
  }
`);

export default KEY_ACTIVE_STUDENT_REPORT_ASYNC_QUERY;
